export const ENVIRONMENT = 'production' //production | development
export const TOKEN_KEY = ENVIRONMENT === 'production' ? '_apex_token' : '_apex_token_dev'
export const SITE_KEY = ENVIRONMENT === 'production' ? '6LefWQYlAAAAAK403XXmn64tLoyR5c2JHDHTGZuJ' : '6LefWQYlAAAAAK403XXmn64tLoyR5c2JHDHTGZuJ'

export const API_ENDPOINT = ENVIRONMENT === 'production' ? 'https://api.apexvitals.com/' : 'https://sapi.apexvitals.com/'
export const IDLE_TIME_IN_SECONDS = 300

export const ENCRYPT_AND_DECRYPT_KEY = 'wjEXA38AgXM1FWTxojcsBqykcV9NpX3h' 
export const DATA_VECTOR = 'dGEBTb1YQszEhk5G' 